import './style.css';
import Home from './view/home';
import Login from './view/login';
import Planos from './view/planos';
import AjudaView from './view/ajuda';
import Suporte from './view/suporte';
import { Provider } from 'react-redux';
import Cadastrar from './view/cadastrar';
import { store, persistor } from './store';
import TermosDeUso from './view/termos-uso';
import PDFViewer from './components/PDFViewer';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import PageNotFound from './view/page-not-found';
import { comPermissao } from './components/sem-acesso';
import RelatorioGeral from './view/relatorios/geral';
import MultaListagem from './view/movimentacoes/multas';
import ReportarProblemas from './view/reportar-problemas';
import PecaListagem from './view/cadastros/pecas/listagem';
import EstoqueListagem from './view/movimentacoes/estoque';
import LocacaoListagem from './view/movimentacoes/locacao';
import Onboarding from './view/onboarding';
import { RastreadorDePaginas } from './services/rastreamentoTeste';
import { PersistGate } from 'redux-persist/integration/react';
import RelatorioFinanceiro from './view/relatorios/financeiro';
import RelatorioComissoes from './view/relatorios/financeiro/comissoes';
import PagamentoListagem from './view/movimentacoes/pagamentos';
import VeiculoListagem from './view/cadastros/veiculos/listagem';
import FilialListagem from './view/cadastros/filiais/listagem';
import { FilialLoteProvider } from './components/modal-selecionar-filial/FilialLoteProvider';
import ServicoListagem from './view/cadastros/servicos/listagem';
import LancamentoListagem from './view/movimentacoes/lancamento';
import EmpresaListagem from './view/cadastros/empresas/listagem';
import UsuarioListagem from './view/cadastros/usuarios/listagem';
import LocatarioListagem from './view/cadastros/locatarios/listagem';
import CategoriaListagem from './view/cadastros/categorias/listagem';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ServicoVeiculoListagem from './view/movimentacoes/manutencao';
import PrestadorDeServicoListagem from './view/cadastros/prestador-servico/listagem';
import { MinhaConta } from './components/minha-conta';
import CheckoutPage from './components/checkout_v2';
import CupomListagemm from './view/cadastros/cupom/listagem';
import Renovar from './view/renovar';
import { NotificationsPage } from './view/NotificationsPage';
import ModeloContratoListagem from './view/cadastros/modelo-contrato/listagem';
import DocxEditor from './view/docx-editor';
import DocxEditorV2 from './view/docx-editor-v2';
import TrocaDeOleoListagem from './view/movimentacoes/troca-de-oleo';
import PlanoManutencaoListagem from './view/movimentacoes/plano-manutencao';
import MapaVeiculos from './view/movimentacoes/mapa-veiculos';
import VistoriaListagem from './view/movimentacoes/vistoria';
import AppLocatarioView from './view/app-locatario';
import NotasFiscaisListagem from './view/movimentacoes/notas-fiscais';
import AuditoriaListagem from './view/auditoria';
import PaymentListener from './components/PaymentListener';
import PesquisasPage from './view/pesquisas';
import BancoListagem from './view/cadastros/financeiro/bancos/listagem';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import { LocaSmartLayout } from './components/locasmart-layout';
import AfiliacaoPage from './view/afiliacao';
import MeuSite from './view/meu-site';
import GestaoRiscoListagem from './view/gestao-risco/listagem';

// Esconde a aba inativa (keep-alive) SEM display:none. O display:none colapsa a caixa
// para 0x0; o MUI DataGrid le clientWidth/clientHeight (=0) e so refaz a geometria depois
// de um ResizeObserver debounced ao reaparecer — e esse atraso e o "carrega em pedaços".
// Mantendo a pagina fora-de-tela com tamanho real, o grid nunca e medido em 0 e nao pisca.
// Usa position:absolute (nao transform) p/ nao virar containing-block de position:fixed.
const cachedRouteBehavior = (hidden: boolean) =>
  hidden
    ? {
        style: {
          position: 'absolute' as const,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          visibility: 'hidden' as const,
          pointerEvents: 'none' as const,
          zIndex: -1,
        },
      }
    : undefined;

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <FilialLoteProvider>
        <Router>
          <PaymentListener />
          <RastreadorDePaginas />
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          {/*
            Roteamento em duas camadas:
            - Full-screen (login, cadastro, checkout, pdf-viewer) ficam FORA da chrome.
            - Resto = app autenticado, com a chrome (LocaSmartLayout) renderizada UMA unica vez em
              volta do CacheSwitch. O <LocaSmartLayout> interno de cada pagina vira pass-through
              (LayoutMountedContext), tirando a chrome do subtree de keep-alive — assim a troca de
              aba so refaz layout da area de conteudo (rapido), sem repintar sidebar/header.
            Keep-alive: telas que viram aba (TAB_ROUTE_MAP) usam <CacheRoute> (montadas e escondidas
            com display:none); cacheKey == path == id da tab, p/ dropByCacheKey ao fechar a aba.
          */}
          <Switch>
            <Route exact path='/' component={Login} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/cadastrar' component={Cadastrar} />
            <Route exact path="/checkout" component={CheckoutPage} />
            <Route exact path="/checkout/:plano" component={CheckoutPage} />
            <Route path="/pdf-viewer" component={PDFViewer} />
            <Route exact path='/planos' component={Planos} />
            <Route exact path='/onboarding' component={Onboarding} />
            <Route exact path='/editor-contrato' component={DocxEditor} />
            <Route exact path='/editor-contrato-v2' component={DocxEditorV2} />
            <Route>
              <LocaSmartLayout>
                <CacheSwitch>
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/home' path='/home' component={comPermissao(Home)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/veiculo' path='/veiculo' component={comPermissao(VeiculoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/filiais' path='/filiais' component={comPermissao(FilialListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/servico' path='/servico' component={comPermissao(ServicoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/locatarios' path='/locatarios' component={comPermissao(LocatarioListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/prestador-servico' path='/prestador-servico' component={comPermissao(PrestadorDeServicoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/peca' path='/peca' component={comPermissao(PecaListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/manutencoes' path='/manutencoes' component={comPermissao(ServicoVeiculoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/estoque' path='/estoque' component={comPermissao(EstoqueListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/locacao' path='/locacao' component={comPermissao(LocacaoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/pagamento' path='/pagamento' component={comPermissao(PagamentoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/lancamento' path='/lancamento' component={comPermissao(LancamentoListagem)} />
                  <Route exact path='/relatorios' component={comPermissao(Home)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/empresas' path='/empresas' component={comPermissao(EmpresaListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/usuarios' path='/usuarios' component={comPermissao(UsuarioListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/relatorio-geral' path='/relatorio-geral' component={comPermissao(RelatorioGeral)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/relatorio-financeiro' path='/relatorio-financeiro' component={comPermissao(RelatorioFinanceiro)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/relatorio-comissoes' path='/relatorio-comissoes' component={comPermissao(RelatorioComissoes)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/ajuda' path='/ajuda' component={comPermissao(AjudaView)} />
                  <Route exact path='/reportar-problemas' component={ReportarProblemas} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/suporte' path='/suporte' component={comPermissao(Suporte)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/multas' path='/multas' component={comPermissao(MultaListagem)} />
                  <Route exact path="/termos-de-uso" component={TermosDeUso} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/categoria' path="/categoria" component={comPermissao(CategoriaListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/minha-conta' path="/minha-conta" component={comPermissao(MinhaConta)} />
                  <Route exact path="/cupom-rota-secret" component={CupomListagemm} />
                  <Route exact path="/renovar" component={Renovar} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/notifications' path="/notifications" component={comPermissao(NotificationsPage)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/modelo-contrato' path="/modelo-contrato" component={comPermissao(ModeloContratoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/troca-de-oleo' path="/troca-de-oleo" component={comPermissao(TrocaDeOleoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/plano-manutencao' path="/plano-manutencao" component={comPermissao(PlanoManutencaoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/mapa-veiculos' path="/mapa-veiculos" component={comPermissao(MapaVeiculos)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/vistoria' path="/vistoria" component={comPermissao(VistoriaListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/app-locatario' path="/app-locatario" component={comPermissao(AppLocatarioView)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/notas-fiscais' path="/notas-fiscais" component={comPermissao(NotasFiscaisListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/auditoria' path="/auditoria" component={comPermissao(AuditoriaListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/pesquisas' path="/pesquisas" component={comPermissao(PesquisasPage)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/cadastros/financeiro/bancos' path="/cadastros/financeiro/bancos" component={comPermissao(BancoListagem)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/afiliacao' path="/afiliacao" component={comPermissao(AfiliacaoPage)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/meu-site' path="/meu-site" component={comPermissao(MeuSite)} />
                  <CacheRoute exact when="always" saveScrollPosition behavior={cachedRouteBehavior} cacheKey='/gestao-risco' path="/gestao-risco" component={comPermissao(GestaoRiscoListagem)} />
                  <Route path='*' component={PageNotFound} />
                </CacheSwitch>
              </LocaSmartLayout>
            </Route>
          </Switch>
        </Router>
        </FilialLoteProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;